import { Outlets } from 'shared/presenters/graphqlTypes'

const hasVouchers = (outlet: Outlets) => {
  return (
    (outlet?.feature_toggles?.credit_vouchers_enabled &&
      outlet?.credit_vouchers_purchasable) ||
    (outlet?.feature_toggles?.class_passes_enabled &&
      outlet?.class_passes_aggregate?.aggregate?.count)
  )
}

export default hasVouchers
